import React, { useMemo, useRef, useState } from "react";
import PlotlyPlot from "react-plotly.js";
import classNames from "classnames";
import { plotLayout, plotConfig, prepareGraphData } from "./utils";
import { renderNumberValue } from "utils/string";
import { useRoundTickValueObserver, useClonePlotClosestLegend } from "shared/plotly/hooks";
import Input from "rs-components/Input";
import NumberInput from "rs-components/Input/components/NumberInput";
import * as styles from "./styles.module.scss";
import * as dynamicFieldsStyles from "../../styles.module.scss";
const RefinementDynamicFields = ({ refinementResult, children }) => {
    const plotRef = useRef(null);
    const [plotHoverEvent, setPlotHoverEvent] = useState(null);
    const preparedGraphData = useMemo(() => {
        if (!refinementResult?.data?.points) {
            return [];
        }
        return prepareGraphData(refinementResult.data.points);
    }, [refinementResult?.data?.points]);
    useClonePlotClosestLegend(plotRef?.current?.el, plotHoverEvent);
    useRoundTickValueObserver(plotRef);
    return (React.createElement("div", { className: styles.root },
        React.createElement("div", { className: styles.value },
            React.createElement(Input, { label: "Most likely value", name: "mostLikely", component: NumberInput, value: renderNumberValue(refinementResult?.data?.mostLikely), classes: {
                    container: classNames(dynamicFieldsStyles.field, styles.mostLikely),
                    label: dynamicFieldsStyles.label,
                }, readonly: true }),
            children),
        React.createElement("div", { className: styles.graph },
            React.createElement("p", { className: styles["graph-title"] }, "Likelihood"),
            React.createElement(PlotlyPlot, { ref: plotRef, config: plotConfig, data: preparedGraphData, layout: plotLayout, className: styles.plot, onHover: setPlotHoverEvent, onUnhover: setPlotHoverEvent }))));
};
export default RefinementDynamicFields;
